import type { OfferFormData } from '../offers/offerForm';
import type { DefinitionFormData } from '../CampaignDefinitionStep';

const formatDate = (iso: string) => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('T')[0].split('-');
  return `${d}/${m}/${y}`;
};

const formatDateTime = (iso: string) => {
  const time = iso.split('T')[1];
  return time ? `${formatDate(iso)} à ${time.slice(0, 5)}` : formatDate(iso);
};

export const formatPeriod = (start: string, end: string) =>
  start || end ? `Du ${formatDateTime(start)} au ${formatDateTime(end)}` : null;

export const formatSchedule = (definition: DefinitionFormData): string | null => {
  if (definition.isRecurring) return 'Envoi récurrent';
  if (definition.channel === 'cashdesk') {
    if (definition.isPreEdited) return 'Offre pré-éditée';
    if (!definition.editionDateStart) return null;
    const end = definition.editionDateEnd ? ` au ${formatDateTime(definition.editionDateEnd)}` : '';
    return `Édition du ${formatDateTime(definition.editionDateStart)}${end}`;
  }
  if (!definition.sendDate) return null;
  return definition.channel === 'courrier'
    ? `Date de dépôt poste : ${formatDate(definition.sendDate)}`
    : `Envoi programmé le ${formatDateTime(definition.sendDate)}`;
};

export const formatDiscount = (offer: OfferFormData): string | null => {
  if (offer.discountTypeId === 2 && offer.pointsValue) {
    return offer.pointsMode === 'multiplication' ? `× ${offer.pointsValue} pts` : `+ ${offer.pointsValue} pts`;
  }
  if ((offer.discountTypeId === 1 || offer.discountTypeId === 3) && offer.remiseValue) {
    return offer.remiseMode === 'pourcentage' ? `Remise ${offer.remiseValue} %` : `Remise ${offer.remiseValue} €`;
  }
  return null;
};
